import React from 'react';
import NotHomePageNavBar from "./NotHomePageNavBar";
import "../components/portStyle.css";
import Footer from "./Footer";
import Meal1 from "../assets/MealPlanner1.png";
import Meal2 from "../assets/RecipeResults.png";
import Meal3 from "../assets/RecipesSaved.png";
import galleryHomepage from "../assets/galleryHomepage.png";
import signUp from "../assets/signUp.png";
import browseArt from "../assets/browseArt.png";
import pic1 from "../assets/pic1.PNG";
import pic2 from "../assets/pic2.PNG";
import example from "../assets/example.PNG";
import ledger from "../assets/ledger.png";
import transactions from "../assets/transactions.png";
import ody from "../assets/pic11.PNG";
import dogAge from "../assets/dogAge.png";

const Portfolio = () => {
  return (
        <div>
            
            <NotHomePageNavBar />
            
                <div className="containerProject1">
                    <div>
                        <div>
                            <h1>Project #1: Meal Planner</h1>
                            <h3>Plan all your meals a week ahead and save your recipes so you can use them throughout the week! Not only can you
                                search and save recipes, but add a random cocktail also on those special nights!
                            </h3>
                            <h5>Technologies Used: HTML 5, CSS, , MealDB, Luxon, JQuery, Materialize, Rest API</h5>
                        </div>

                        
                        <div>
                            <img className="mealPlanner1" src={Meal1} alt="Meal Planner Home Page" />
                            <img className="mealPlanner1" src={Meal2} alt="Recipe Search with Random Cocktail" />
                            <img className="mealPlanner1" src={Meal3} alt="Meal Planner Saved Recipes in the Calendar" />
                        </div>

                        <div>                    
                            <a style={{color: "black"}} href="https://kodiakshuksan.github.io/MealPlanner/" alt="Link to Meal Planner Application">
                                Meal
                                Planner Link</a>
                         |

                            <a style={{color: "black"}} href="https://github.com/kodiakshuksan/MealPlanner" alt="Meal Planner @ GitHub">Meal Planner
                                @
                                GitHub</a>
                        </div>
                    </div>
                </div>  

        
                <div className="containerProject">
                    <div>
                        <div>
                            <h1>Project #2: My-Mini-Gallery</h1>
                            <h3>This repository is for a web application that allows users to discover, view, and share artwork with each other
                                online.The goal is for artists to use this website to build up a portfolio and then be able to communicate with
                                other creative minds, get feedback, and build a fan-base.</h3>
                                <h5>Technologies Used: HTML 5, CSS, Node.js, Javascript, npm, express, ReactJS, MongoDB, Bootstrap, AWS, mongoose</h5>
                        </div>

                        <div>
                            <img className="mealPlanner1" src={galleryHomepage} alt="Gallery HomePage" />    
                            <img className="mealPlanner1" src={signUp} alt="Sign Up Page" />
                            <img className="mealPlanner1" src={browseArt} alt="Browse Art Page" />
                        </div>

                        <div>
                            <a style={{color: "black"}} href="https://my-mini-gallery.herokuapp.com" alt="Deployed Application Link">My-Mini-Gallery Link</a>
                            ||
                            <a href="https://kodiakshuksan.github.io/PassWordTryAgain/" alt="My-Mini-Gallery @ GitHub">My-Mini-Gallery @ GitHub</a>
                        </div>
                    </div>
                </div>

                <div className="containerProject">
                    <div>
                        <div>
                            <h1>Project #3: ReadMe Generator</h1>
                            <h3>Creates a ReadMe for your program after a series of questions are answered!</h3>
                            <h5>Technologies Used: HTML 5, CSS, Node.js, React.JS, Javascript, npm, express, MongoDB, Bootstrap, AWS</h5>
                        </div>
                            <div>
                                <img className="mealPlanner1" src={example} alt="" />
                                <img className="mealPlanner1" src={pic1} alt="" />
                                <img className="mealPlanner1" src={pic2} alt="" />
                            </div>

                            <a href="https://github.com/kodiakshuksan/README_Gen" alt="Link to Application">ReadMe Generator</a>
                            ||
                            <a href="https://github.com/kodiakshuksan/README_Gen" alt="ReadME Generator @ GitHub">ReadME Generator @
                            GitHub</a>
                    </div>
                </div>

                <div className="containerProject">
                    <div>
                        <h1>Project #4: BudgetTracker</h1>
                        <h3>Helps you to keep track of your expenses and credits when you are online and offline</h3>
                        <h5>Technologies Used: HTML 5, CSS, NodeJS, Javascript, npm, express, MongoDB, Bootstrap</h5>

                        <div>
                            <img className="mealPlanner1" src={transactions} alt="" />
                            <img className="mealPlanner1" src={ledger} alt="" />
                        </div>

                            <a href="https://still-eyrie-45509.herokuapp.com/" alt="Link to Application">Budget Tracker Link</a>
                            ||
                            <a href="https://github.com/kodiakshuksan/BudgetTracker" alt="ReadME Generator @ GitHub">Budget Tracker @
                            GitHub</a>
                    </div>
                </div>

                <div className="containerProjectEnd">
                    <div>
                        <h1>Project #5: OdiApp</h1>
                        <h3>Have you ever wondered how old your dog is in Dog Years? This application converts your dog's
                            age in human years into dog years!
                        </h3>
                        <h5>Technologies Used: HTML 5, CSS, Adobe, Javascript, Bootstrap</h5>
                        
                        <div>
                            <img className="mealPlanner1" src={ody} alt="dog pic" />
                            <img className="mealPlanner1" src={dogAge} alt="dog pic with age" />
                        </div>
                        
                        <a href="https://kodiakshuksan.github.io/OdyApp/" alt="Link to OdyApp">OdyApp Link</a>
                        ||
                        <a href="https://github.com/kodiakshuksan/OdyApp" alt="OdyApp @ GitHub">OdyApp @ GitHub</a>
                    </div>
                </div>         
 <Footer />
            
</div>
  );
}

export default Portfolio
